import api from '../interceptors/axiosConfig';

const base = (process.env.REACT_APP_LOTTO_API_BASE_URL || '/api/v1').replace(/\/$/, '');
export interface AccessScope { key: string; label: string; eligible_roles: string[]; }
export interface StoreAccessSettings { access_scopes: string[]; role: string; receive_daily_reconciliation_email: boolean; }
export const storeAccessService = {
    async catalog(storeId: string): Promise<AccessScope[]> {
        return (await api.get(`${base}/stores/${storeId}/access/scopes`)).data;
    },
    async get(storeId: string, userId: string): Promise<StoreAccessSettings> {
        return (await api.get(`${base}/admin/stores/${storeId}/users/${userId}/access`)).data;
    },
    async save(storeId: string, userId: string, scopes: string[], receiveDailyEmail: boolean): Promise<void> {
        await api.put(`${base}/admin/stores/${storeId}/users/${userId}/access`, { access_scopes: scopes, receive_daily_reconciliation_email: receiveDailyEmail });
    },
};
